import React, { createContext, useContext, useEffect, useState } from "react";

const DICT = {
  en: {
    nav_products: "Products", nav_refer: "Refer & Earn", nav_top: "Top Performers",
    nav_calculator: "Calculator", nav_tools: "Tools", nav_knowledge: "Knowledge",
    nav_bulk: "Bulk Work", nav_getapp: "Get App",
    nav_login: "Login", nav_register: "Register", nav_dashboard: "Dashboard", nav_console: "Console",
    footer_tagline: "India's direct Refer & Earn fintech marketplace. Browse financial products, refer, and earn transparent multi-level rewards.",
    footer_company: "Company", footer_support: "Support", footer_legal: "Legal",
    footer_about: "About Credit Kendra", footer_products: "Products", footer_refer: "Refer & Earn",
    footer_top: "Top Performers", footer_help: "Help & Support", footer_contact: "Contact",
    footer_faq: "FAQ", footer_calculator: "Calculator",
    footer_terms: "Terms & Conditions", footer_privacy: "Privacy Policy", footer_refund: "Refund Policy",
    footer_rights: "Credit Kendra All rights reserved.",
    footer_disclaimer: "Credit Kendra is a referral & lead-generation platform. We are not a bank, NBFC, lender, broker, AMC, or insurer. All financial products are offered by respective regulated partners. Rewards are subject to verified conversions and campaign terms. No guaranteed income or assured approval.",
    hero_badge: "INDIA'S DIRECT REFER & EARN FINTECH",
    hero_title_1: "Apply, refer & earn", hero_title_2: "transparent rewards",
    hero_subtitle: "Discover demat, loans, credit cards & more. Share your referral link, set your own payout split, and watch multi-level rewards hit your wallet.",
    hero_cta_start: "Start Earning", hero_cta_browse: "Browse Products",
    hero_feat_1: "Multi-level payouts", hero_feat_2: "Immutable wallet ledger", hero_feat_3: "Instant referral links",
    ex_title: "3-level example", ex_l1: "You (L1)", ex_l2: "Your referral (L2)", ex_l3: "Their referral (L3 · converts)",
    ex_alloc: "Allocation", ex_total: "Total distributed",
    dash_home: "Dashboard", dash_refer: "Refer & Earn", dash_leadstatus: "Lead Status",
    dash_wallet: "Earnings Wallet", dash_withdraw: "Withdraw", dash_network: "My Network",
    dash_kyc: "KYC", dash_shopping: "Shopping", dash_recharge: "Recharge",
    dash_billpay: "Bill Pay", dash_support: "Support", dash_profile: "Profile", dash_signout: "Sign out",
    ref_subtitle: "Select a campaign, set your payout split, and generate a tracked referral link.",
    ref_payout_note: "You earn this on every successful conversion",
    ref_slab_title: "Slab payout — more leads, higher rate",
    ref_bulk_rates: "Bulk partner — your rates are set by the admin",
    ref_max_note: "Max {max} (campaign limit) — you cannot set higher",
    ref_max_toast: "Max for this campaign is {max}",
    ref_cat_hint: "Click a category — below you will see only that category's campaign links.",
    ref_links_sub: "Payout per successful referral — share the link and earn on every successful referral.",
    ref_src_hint: "— added to the link; source-wise performance shows in the dashboard",
    ref_no_links: "No campaign links available in this category yet.",
    ref_invite_bonus: "Friend gets a signup bonus + you get ₹{amount} referral bonus (credited when your friend earns ₹{min}+ and makes their first withdrawal). Eligible this month: {used}/{cap}.",
    ref_invite_wa: "Sign up on Credit Kendra and get ₹{amount} Signup Bonus!\n\nRegister using my referral link: {link}\n\n*T&C: Bonus is credited only after you earn ₹{min}+ and make your first withdrawal.",
    ref_tnc: "*T&C Apply: Signup bonus of ₹{amount} is credited only when your referred friend earns ₹{min}+ and makes their first withdrawal. Max {cap} referrals eligible per month. No bonus on fraud/duplicate joins.",
    ref_tracker_sub: "₹{amount} per referral — credited when the referred user makes their first withdrawal after earning ₹{min}+.",
    ref_no_bonus: "No referral bonus yet — share your invite link.",
    ref_link_created: "Referral link created!",
    ref_copied: "Copied to clipboard",
    kyc_dob_hint: "Minimum age 18 years is required.",
    kyc_ifsc_loading: "Looking up bank details…",
    kyc_ifsc_error: "IFSC not found — please check.",
    kyc_aadhaar_note: "For security, only the last 4 digits are stored (masked).",
    kyc_aadhaar_onfile: " On file: {aad} — enter a new 12-digit number to change it.",
    kyc_aadhaar_notlinked: "My Aadhaar-linked mobile number is not active — I will upload the Aadhaar card document manually",
    kyc_aadhaar_docnote: "Document upload is mandatory if the Aadhaar-linked number is not active — our team will verify it manually.",
    kyc_submitted: "KYC submitted for review.",
    ls_subtitle: "Check the status of leads from your link anytime here. Payment is released only after brand confirmation.",
    ls_mobile_ph: "Customer's 10-digit mobile number",
    ls_perf_note: "How many leads and conversions came from which source (WhatsApp/FB/Insta…). Tag a source in your link to see it here.",
    ls_empty: "No leads found for this mobile number. First get the customer to apply via your campaign link.",
    net_subtitle: "Your multi-level network — expand each member to see their earnings.",
    net_empty: "You haven't referred anyone yet. Share your invite link from Refer & Earn.",
    ap_offer_live: "Offer Live",
    ap_apply_now: "Apply now",
    ap_payment_note: "Payment will be released only after confirmation from the brand.",
    ap_full_name: "Full Name",
    ap_name_ph: "Your name (letters only)",
    ap_mobile: "Mobile Number",
    ap_mobile_ph: "10-digit mobile",
    ap_pincode: "Pincode",
    ap_pincode_ph: "6-digit pincode — offer works only where available",
    ap_email: "Email Address",
    ap_email_ph: "you@example.com",
    ap_consent: "I allow Credit Kendra and its partner brands to use my details only for this application/campaign purpose. I have read the Privacy Policy.",
    ap_submit: "Submit application",
    ap_continue: "Continue to application",
    ap_wait: "Please wait…",
    ap_redirect_note: "You will be redirected to the official application page.",
    ap_checker_title: "Check your lead status",
    ap_checker_sub: "Already applied? Enter your mobile to check if your lead was tracked.",
    ap_checker_ph: "Your mobile number",
    ap_check_btn: "Check",
    ap_success_title: "Application submitted successfully!",
    ap_success_sub: "Your details have been received. Payment will be released only after confirmation from the brand.",
    ap_unavailable: "Campaign currently unavailable.",
    ap_consent_toast: "Please tick the consent checkbox to continue.",
  },
  hi: {
    nav_products: "प्रोडक्ट्स", nav_refer: "रेफ़र और कमाएँ", nav_top: "टॉप परफ़ॉर्मर्स",
    nav_calculator: "कैलकुलेटर", nav_tools: "टूल्स", nav_knowledge: "जानकारी",
    nav_bulk: "बल्क वर्क", nav_getapp: "ऐप पाएँ",
    nav_login: "लॉगिन", nav_register: "रजिस्टर", nav_dashboard: "डैशबोर्ड", nav_console: "कंसोल",
    footer_tagline: "भारत का सीधा रेफ़र और कमाई फिनटेक मार्केटप्लेस। फाइनेंशियल प्रोडक्ट्स देखें, रेफ़र करें और पारदर्शी मल्टी-लेवल रिवॉर्ड कमाएँ।",
    footer_company: "कंपनी", footer_support: "सहायता", footer_legal: "कानूनी",
    footer_about: "Credit Kendra के बारे में", footer_products: "प्रोडक्ट्स", footer_refer: "रेफ़र और कमाएँ",
    footer_top: "टॉप परफ़ॉर्मर्स", footer_help: "मदद और सहायता", footer_contact: "संपर्क",
    footer_faq: "FAQ", footer_calculator: "कैलकुलेटर",
    footer_terms: "नियम और शर्तें", footer_privacy: "प्राइवेसी पॉलिसी", footer_refund: "रिफंड पॉलिसी",
    footer_rights: "Credit Kendra सर्वाधिकार सुरक्षित।",
    footer_disclaimer: "Credit Kendra एक रेफ़रल और लीड-जेनरेशन प्लेटफ़ॉर्म है। हम बैंक, NBFC, लेंडर, ब्रोकर, AMC या इंश्योरर नहीं हैं। सभी फाइनेंशियल प्रोडक्ट्स संबंधित रेग्युलेटेड पार्टनर्स द्वारा दिए जाते हैं। रिवॉर्ड सत्यापित कन्वर्ज़न और कैंपेन शर्तों के अधीन हैं। कोई गारंटीड इनकम या पक्का अप्रूवल नहीं।",
    hero_badge: "भारत का सीधा रेफ़र और कमाई फिनटेक",
    hero_title_1: "अप्लाई करें, रेफ़र करें और कमाएँ", hero_title_2: "पारदर्शी रिवॉर्ड",
    hero_subtitle: "डीमैट, लोन, क्रेडिट कार्ड और बहुत कुछ खोजें। अपना रेफ़रल लिंक शेयर करें, अपना पेआउट स्प्लिट चुनें, और मल्टी-लेवल रिवॉर्ड अपने वॉलेट में पाएँ।",
    hero_cta_start: "कमाई शुरू करें", hero_cta_browse: "प्रोडक्ट्स देखें",
    hero_feat_1: "मल्टी-लेवल पेआउट", hero_feat_2: "इम्यूटेबल वॉलेट लेजर", hero_feat_3: "तुरंत रेफ़रल लिंक",
    ex_title: "3-लेवल उदाहरण", ex_l1: "आप (L1)", ex_l2: "आपका रेफ़रल (L2)", ex_l3: "उनका रेफ़रल (L3 · कन्वर्ट)",
    ex_alloc: "अलोकेशन", ex_total: "कुल वितरण",
    dash_home: "डैशबोर्ड", dash_refer: "रेफ़र और कमाएँ", dash_leadstatus: "लीड स्टेटस",
    dash_wallet: "कमाई वॉलेट", dash_withdraw: "विथड्रॉ", dash_network: "मेरा नेटवर्क",
    dash_kyc: "KYC", dash_shopping: "शॉपिंग", dash_recharge: "रिचार्ज",
    dash_billpay: "बिल पे", dash_support: "सहायता", dash_profile: "प्रोफ़ाइल", dash_signout: "साइन आउट",
    ref_subtitle: "कैंपेन चुनें, अपना पेआउट स्प्लिट सेट करें और ट्रैक्ड रेफ़रल लिंक बनाएं।",
    ref_payout_note: "हर सफल कन्वर्ज़न पर आपको इतना मिलेगा",
    ref_slab_title: "स्लैब पेआउट — ज़्यादा लीड्स, ज़्यादा रेट",
    ref_bulk_rates: "बल्क पार्टनर — आपकी रेटें एडमिन सेट करते हैं",
    ref_max_note: "अधिकतम {max} (कैंपेन लिमिट) — इससे ज़्यादा सेट नहीं कर सकते",
    ref_max_toast: "इस कैंपेन के लिए अधिकतम {max} है",
    ref_cat_hint: "कैटेगरी पर क्लिक करें — नीचे सिर्फ उसी कैटेगरी के कैंपेन लिंक दिखेंगे।",
    ref_links_sub: "हर सफल रेफ़रल पर पेआउट — लिंक शेयर करें और हर सफल रेफ़रल पर कमाएं।",
    ref_src_hint: "— लिंक में जुड़ जाएगा; डैशबोर्ड में सोर्स-वाइज़ परफ़ॉर्मेंस दिखेगी",
    ref_no_links: "इस कैटेगरी में अभी कोई कैंपेन लिंक उपलब्ध नहीं है।",
    ref_invite_bonus: "दोस्त को साइनअप बोनस + आपको ₹{amount} रेफ़रल बोनस (तब क्रेडिट होगा जब दोस्त ₹{min}+ कमाकर पहला विथड्रॉल करेगा)। इस महीने eligible: {used}/{cap}।",
    ref_invite_wa: "Credit Kendra पर Signup करें और ₹{amount} Signup Bonus पाएं!\n\nमेरी रेफ़रल लिंक से रजिस्टर करें: {link}\n\n*T&C: बोनस तभी मिलेगा जब आप ₹{min}+ कमाकर पहला विथड्रॉल करेंगे।",
    ref_tnc: "*T&C लागू: ₹{amount} का साइनअप बोनस तभी क्रेडिट होगा जब आपका रेफ़र किया दोस्त ₹{min}+ कमाकर पहला विथड्रॉल करेगा। हर महीने अधिकतम {cap} रेफ़रल eligible। फ्रॉड/डुप्लिकेट जॉइन पर बोनस नहीं मिलेगा।",
    ref_tracker_sub: "₹{amount} प्रति रेफ़रल — तब क्रेडिट होगा जब रेफ़र किया गया यूज़र ₹{min}+ कमाकर पहला विथड्रॉल करेगा।",
    ref_no_bonus: "अभी कोई रेफ़रल बोनस नहीं — अपनी इनवाइट लिंक शेयर करें।",
    ref_link_created: "रेफ़रल लिंक बन गया!",
    ref_copied: "कॉपी हो गया",
    kyc_dob_hint: "न्यूनतम उम्र 18 वर्ष आवश्यक है।",
    kyc_ifsc_loading: "बैंक डिटेल्स खोजी जा रही हैं…",
    kyc_ifsc_error: "IFSC नहीं मिला — कृपया जांचें।",
    kyc_aadhaar_note: "सुरक्षा के लिए सिर्फ आखिरी 4 अंक स्टोर होते हैं (मास्क्ड)।",
    kyc_aadhaar_onfile: " फाइल पर: {aad} — बदलने के लिए नया 12-अंकों का नंबर दर्ज करें।",
    kyc_aadhaar_notlinked: "मेरा आधार-लिंक्ड मोबाइल नंबर एक्टिव नहीं है — मैं आधार कार्ड डॉक्यूमेंट मैन्युअली अपलोड करूंगा",
    kyc_aadhaar_docnote: "आधार-लिंक्ड नंबर एक्टिव न होने पर डॉक्यूमेंट अपलोड अनिवार्य है — हमारी टीम मैन्युअली वेरिफाई करेगी।",
    kyc_submitted: "KYC रिव्यू के लिए सबमिट हो गई।",
    ls_subtitle: "अपने लिंक से आई लीड्स का स्टेटस यहां कभी भी चेक करें। पेमेंट ब्रांड कन्फर्मेशन के बाद ही रिलीज़ होता है।",
    ls_mobile_ph: "कस्टमर का 10-अंकों का मोबाइल नंबर",
    ls_perf_note: "कौन से सोर्स (WhatsApp/FB/Insta…) से कितनी लीड्स और कन्वर्ज़न आए। लिंक में सोर्स टैग करने पर यहां दिखेगा।",
    ls_empty: "इस मोबाइल नंबर की कोई लीड नहीं मिली। पहले कस्टमर को अपने कैंपेन लिंक से अप्लाई करवाएं।",
    net_subtitle: "आपका मल्टी-लेवल नेटवर्क — हर मेंबर को एक्सपैंड करके उनकी कमाई देखें।",
    net_empty: "आपने अभी तक किसी को रेफ़र नहीं किया। Refer & Earn से अपनी इनवाइट लिंक शेयर करें।",
    ap_offer_live: "ऑफर लाइव",
    ap_apply_now: "अभी अप्लाई करें",
    ap_payment_note: "भुगतान ब्रांड की कन्फर्मेशन के बाद ही रिलीज़ होगा।",
    ap_full_name: "पूरा नाम",
    ap_name_ph: "आपका नाम (सिर्फ अक्षर)",
    ap_mobile: "मोबाइल नंबर",
    ap_mobile_ph: "10-अंकों का मोबाइल",
    ap_pincode: "पिनकोड",
    ap_email: "ईमेल एड्रेस",
    ap_email_ph: "you@example.com",
    ap_pincode_ph: "6-अंकों का पिनकोड — ऑफर उपलब्ध क्षेत्र में ही काम करेगा",
    ap_consent: "मैं Credit Kendra और उसके पार्टनर ब्रांड्स को सिर्फ इस एप्लिकेशन/कैंपेन उद्देश्य के लिए अपनी डिटेल्स शेयर करने की अनुमति देता/देती हूं। मैंने Privacy Policy पढ़ ली है।",
    ap_submit: "एप्लिकेशन सबमिट करें",
    ap_continue: "एप्लिकेशन पर जाएं",
    ap_wait: "कृपया प्रतीक्षा करें…",
    ap_redirect_note: "आपको ऑफिशियल एप्लिकेशन पेज पर रीडायरेक्ट किया जाएगा।",
    ap_checker_title: "अपनी लीड का स्टेटस चेक करें",
    ap_checker_sub: "पहले अप्लाई किया? अपना मोबाइल डालकर चेक करें कि आपकी लीड ट्रैक हुई या नहीं।",
    ap_checker_ph: "आपका मोबाइल नंबर",
    ap_check_btn: "चेक करें",
    ap_success_title: "एप्लिकेशन सफलतापूर्वक सबमिट हो गया!",
    ap_success_sub: "आपकी डिटेल्स मिल गई हैं। भुगतान ब्रांड की कन्फर्मेशन के बाद ही रिलीज़ होगा।",
    ap_unavailable: "कैंपेन अभी उपलब्ध नहीं है।",
    ap_consent_toast: "आगे बढ़ने के लिए consent checkbox टिक करें।",
  },
  hinglish: {
    nav_products: "Products", nav_refer: "Refer & Earn", nav_top: "Top Performers",
    nav_calculator: "Calculator", nav_tools: "Tools", nav_knowledge: "Knowledge",
    nav_bulk: "Bulk Work", nav_getapp: "App Lo",
    nav_login: "Login", nav_register: "Register", nav_dashboard: "Dashboard", nav_console: "Console",
    footer_tagline: "India ka direct Refer & Earn fintech marketplace. Financial products browse karo, refer karo, aur transparent multi-level rewards kamao.",
    footer_company: "Company", footer_support: "Support", footer_legal: "Legal",
    footer_about: "Credit Kendra ke baare me", footer_products: "Products", footer_refer: "Refer & Earn",
    footer_top: "Top Performers", footer_help: "Help & Support", footer_contact: "Contact",
    footer_faq: "FAQ", footer_calculator: "Calculator",
    footer_terms: "Terms & Conditions", footer_privacy: "Privacy Policy", footer_refund: "Refund Policy",
    footer_rights: "Credit Kendra All rights reserved.",
    footer_disclaimer: "Credit Kendra ek referral & lead-generation platform hai. Hum bank, NBFC, lender, broker, AMC ya insurer nahi hain. Saare financial products respective regulated partners dete hain. Rewards verified conversions aur campaign terms par depend karte hain. Koi guaranteed income ya assured approval nahi.",
    hero_badge: "INDIA KA DIRECT REFER & EARN FINTECH",
    hero_title_1: "Apply karo, refer karo & kamao", hero_title_2: "transparent rewards",
    hero_subtitle: "Demat, loans, credit cards & more discover karo. Apna referral link share karo, apna payout split set karo, aur multi-level rewards apne wallet me pao.",
    hero_cta_start: "Earning Shuru Karo", hero_cta_browse: "Products Dekho",
    hero_feat_1: "Multi-level payouts", hero_feat_2: "Immutable wallet ledger", hero_feat_3: "Instant referral links",
    ex_title: "3-level example", ex_l1: "Aap (L1)", ex_l2: "Aapka Referral (L2)", ex_l3: "Unka Referral (L3 · converts)",
    ex_alloc: "Allocation", ex_total: "Total distributed",
    dash_home: "Dashboard", dash_refer: "Refer & Earn", dash_leadstatus: "Lead Status",
    dash_wallet: "Earnings Wallet", dash_withdraw: "Withdraw", dash_network: "Mera Network",
    dash_kyc: "KYC", dash_shopping: "Shopping", dash_recharge: "Recharge",
    dash_billpay: "Bill Pay", dash_support: "Support", dash_profile: "Profile", dash_signout: "Sign out",
    ref_subtitle: "Campaign select karo, apna payout split set karo, aur tracked referral link banao.",
    ref_payout_note: "Har successful conversion par aapko itna milega",
    ref_slab_title: "Slab payout — zyada leads, zyada rate",
    ref_bulk_rates: "Bulk partner — aapki rates admin dwara set ki jaati hain",
    ref_max_note: "Max {max} (campaign limit) — zyada set nahi kar sakte",
    ref_max_toast: "Is campaign ka max {max} hai",
    ref_cat_hint: "Category par click karein — neeche sirf usi category ke campaign links dikhenge.",
    ref_links_sub: "Per Successful Refer Payout — link share karein, har successful referral par payout milega.",
    ref_src_hint: "— link me jud jayega, dashboard me source-wise performance dikhegi",
    ref_no_links: "Is category me abhi koi campaign link available nahi hai.",
    ref_invite_bonus: "Friend ko signup bonus + aapko ₹{amount} referral bonus (credit tab hoga jab friend ₹{min}+ earn karke pehla withdrawal karega). Is month eligible: {used}/{cap}.",
    ref_invite_wa: "Credit Kendra par Signup karein aur ₹{amount} Signup Bonus paayein!\n\nMeri referral link se register karein: {link}\n\n*T&C: Bonus tabhi milega jab aap ₹{min}+ earn karke pehla withdrawal karenge.",
    ref_tnc: "*T&C Apply: Signup bonus ₹{amount} tabhi credit hoga jab aapka referred friend ₹{min}+ earn karke pehla withdrawal karega. Per month {cap} referrals eligible. Fraud/duplicate joins par bonus nahi milega.",
    ref_tracker_sub: "₹{amount} per referral — credit tab jab referred user ₹{min}+ ka pehla withdrawal karega.",
    ref_no_bonus: "Abhi koi referral bonus nahi — invite link share karein.",
    ref_link_created: "Referral link ban gaya!",
    ref_copied: "Copy ho gaya",
    kyc_dob_hint: "Minimum age 18 years zaroori hai.",
    kyc_ifsc_loading: "Bank details dhundh rahe hain…",
    kyc_ifsc_error: "IFSC nahi mila — please check karein.",
    kyc_aadhaar_note: "Security ke liye sirf last 4 digits store hote hain (masked).",
    kyc_aadhaar_onfile: " On file: {aad} — badalne ke liye naya 12-digit number enter karein.",
    kyc_aadhaar_notlinked: "Mera Aadhaar-linked mobile number active nahi hai — main Aadhaar card document manually upload karunga",
    kyc_aadhaar_docnote: "Aadhaar-linked number active na hone par document upload mandatory hai — team manually verify karegi.",
    kyc_submitted: "KYC review ke liye submit ho gayi.",
    ls_subtitle: "Aapke link se aayi leads ka status yahan kabhi bhi check karein. Payment brand confirmation ke baad hi release hota hai.",
    ls_mobile_ph: "Customer ka 10-digit mobile number",
    ls_perf_note: "Kaunse source (WhatsApp/FB/Insta…) se kitni leads aur conversions aaye. Link me source tag karne par yahan dikhega.",
    ls_empty: "Is mobile number ki koi lead nahi mili. Pehle customer ko apna campaign link se apply karwayein.",
    net_subtitle: "Aapka multi-level network — har member aur unki earnings expand karke dekhein.",
    net_empty: "Aapne abhi tak kisi ko refer nahi kiya. Refer & Earn se apni invite link share karein.",
    ap_offer_live: "Offer Live",
    ap_apply_now: "Apply now",
    ap_payment_note: "Payment brand confirmation ke baad hi release hoga.",
    ap_full_name: "Full Name",
    ap_name_ph: "Aapka naam (letters only)",
    ap_mobile: "Mobile Number",
    ap_mobile_ph: "10-digit mobile",
    ap_pincode: "Pincode",
    ap_email: "Email Address",
    ap_email_ph: "you@example.com",
    ap_pincode_ph: "6-digit pincode — jahan offer available hai wahi kaam karega",
    ap_consent: "Main apni details Credit Kendra aur iske partner brands ko sirf is application/campaign purpose ke liye share karne ki anumati deta/deti hoon. Privacy Policy padh li hai.",
    ap_submit: "Submit application",
    ap_continue: "Continue to application",
    ap_wait: "Please wait…",
    ap_redirect_note: "Aapko official application page par redirect kiya jayega.",
    ap_checker_title: "Check your lead status",
    ap_checker_sub: "Already applied? Apna mobile daalkar check karein ki aapki lead track hui ya nahi.",
    ap_checker_ph: "Aapka mobile number",
    ap_check_btn: "Check",
    ap_success_title: "Application successfully submit ho gaya!",
    ap_success_sub: "Aapki details mil gayi hain. Payment brand confirmation ke baad hi release hoga.",
    ap_unavailable: "Campaign abhi available nahi hai.",
    ap_consent_toast: "Aage badhne ke liye consent checkbox tick karein.",
  },
};

const LanguageContext = createContext({ lang: "en", setLang: () => {}, t: (k) => k });

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => {
    try { return localStorage.getItem("omi-lang") || "en"; } catch { return "en"; }
  });
  useEffect(() => {
    try { localStorage.setItem("omi-lang", lang); } catch {}
    document.documentElement.lang = lang === "hi" ? "hi" : "en";
  }, [lang]);
  const t = (key, vars) => {
    let s = DICT[lang]?.[key] ?? DICT.en[key] ?? key;
    if (vars) for (const [k, v] of Object.entries(vars)) s = s.split(`{${k}}`).join(String(v));
    return s;
  };
  return <LanguageContext.Provider value={{ lang, setLang, t }}>{children}</LanguageContext.Provider>;
}

export const useLanguage = () => useContext(LanguageContext);

export const LANGS = [
  { code: "en", label: "English" },
  { code: "hi", label: "हिंदी" },
  { code: "hinglish", label: "Hinglish" },
];
